import styled from 'styled-components'
import {
  party_colors,
  party_colors_text,
  party_colors_text_dm,
  party_names,
} from 'components/MainComponent/party_colors'
import { useWindowSize } from 'usehooks-ts'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export const CustomSelect = ({
  label,
  entries,
  onChange,
  current,
  isOpen,
  setOpen,
  colorMode,
}: {
  label: string
  entries: { label: string | number; value: any }[]
  onChange: (value: any) => void
  current: any
  isOpen: boolean
  setOpen: (value: boolean) => void
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const { width, height } = useWindowSize()
  const { t } = useTranslation()
  const defaultValue = current === 'Schweiz' ? 'allParties' : party_names[current] || current

  return (
    <SelectRoot style={{ zIndex: isOpen ? 900 : undefined }}>
      <SelectLabel colorMode={colorMode}>{label}</SelectLabel>
      <Current
        isOpen={isOpen}
        dm={colorMode === 'dark'}
        onClick={() => setOpen(!isOpen)}
        style={{
          backgroundColor: isOpen
            ? current
              ? party_colors[current]
              : 'var(--tooltip-background)'
            : current
            ? party_colors[current]
            : undefined,
          fontWeight: isOpen ? 700 : 400,
          color: isOpen
            ? current
              ? party_colors_text[current]
              : 'var(--brandblue-main)'
            : current
            ? party_colors_text[current]
            : undefined,
          minWidth: width > 711 ? '260px' : width / 2 - 25 + 'px',
        }}
      >
        {typeof(defaultValue) !== "number" ? t(`swissmap:parties:${defaultValue}`).replace('*', '') : defaultValue}
        <Arrow
          color={party_colors_text[current]}
          dir={isOpen ? 'up' : 'down'}
        />
      </Current>
      {isOpen && (
        <List onMouseLeave={() => setOpen(false)}>
          {entries.map(({ label, value }, i) => {
            var lab: string | number | ReactNode = party_names[label] || label
            if (label === 'Schweiz') {
              lab = "allParties"
            }
            return (
              <ListElement
                style={{
                  color:
                    label === current ? 'var(--gray-4)' : party_colors[label],
                  fontWeight: label === current ? 300 : 700,
                }}
                className={label === current ? 'active' : ''}
                wide={label === 'Schweiz' || label === 2023}
                odd={i % (width < 712 ? 2 : 2) == 0}
                onClick={() => {
                  setOpen(false)
                  onChange(value)
                }}
              >
                {typeof(lab) === 'number' ? lab : t(`swissmap:parties:${lab}`).replace('*', '')}
              </ListElement>
            )
          })}
        </List>
      )}
    </SelectRoot>
  )
}

const Arrow = ({
  dir = 'down',
  color = 'var(--brandblue-main)',
}: {
  dir?: 'up' | 'down'
  color?: string
}) => {
  const d_up =
    'm22.12,0c.9,0,1.79.34,2.48,1.03l18.62,18.62c1.37,1.37,1.37,3.58,0,4.95-1.37,1.37-3.58,1.37-4.95,0L22.12,8.45,5.97,24.6c-1.37,1.37-3.58,1.37-4.95,0-1.37-1.37-1.37-3.58,0-4.95L19.65,1.03c.68-.68,1.58-1.03,2.48-1.03Z'
  const d_down =
    'm22.12,25.62c-.9,0-1.79-.34-2.48-1.03L1.03,5.97C-.34,4.61-.34,2.39,1.03,1.02,2.39-.34,4.61-.34,5.98,1.02l16.15,16.15L38.27,1.02c1.37-1.37,3.58-1.37,4.95,0,1.37,1.37,1.37,3.58,0,4.95l-18.62,18.62c-.68.68-1.58,1.03-2.48,1.03Z'
  const d = dir === 'up' ? d_up : d_down
  return (
    <svg
      width={12}
      height={12}
      viewBox='0 0 44.24 25.62'
      style={{ position: 'absolute', right: '15px', fill: color }}
    >
      <path d={d} />
    </svg>
  )
}

const SelectLabel = styled.div<{ colorMode: 'dark' | 'light' | undefined }>`
  color: ${(props) =>
    props.colorMode === 'dark' ? '#e7e7e7' : 'var(--gray-2)'};
  font-size: 13px;
  letter-spacing: 0.2px;
  width: calc(100%);
  text-align: center;
  /* padding-right: 40px; */
  margin-bottom: 5px;
`
const Button = styled.button`
  border: 0;
  background-color: transparent;
  &:hover {
    cursor: pointer;
    /* background-color: var(--gray-3); */
  }
`
const AltButton = styled.div``

const Current = styled(AltButton)<{ dm: boolean; isOpen: boolean }>`
  flex: 0 0 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  margin: 0;
  border: 0;

  background-color: var(--gray-4);
  color: var(--brandblue-main);

  border: 1px solid transparent;

  height: 60px;

  position: relative;

  font-weight: 300;
  font-size: 18px;
  letter-spacing: 0.6px;

  text-align: center;

  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`

const List = styled.div.attrs({ className: 'list' })`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;
  gap: 1px;
  justify-content: flex-start;
  -webkit-box-shadow: 0px 5px 5px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.1);
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
  background-color: var(--gray-5);
`

const ListElement = styled(Button)<{ odd: boolean; wide: boolean }>`
  background-color: #fff;
  color: var(--brandblue-main);
  padding: 10px;
  min-height: 50px;
  flex: 0 0 calc(50% - 10px);
  flex: ${(props) =>
    props.wide ? '1 1 calc(100% - 1px)' : '1 1 calc(50% - 1px)'};

  font-size: 15px;
  letter-spacing: 0.4px;
  font-weight: 700;

  &.active {
  }
  @media screen and (max-width: 711px) {
    flex: ${(props) =>
      props.wide ? '1 1 calc(100% - 4px)' : '0 0 calc(50% - 5px)'};
    font-size: 14px;
    min-height: 50px;
  }

  &:hover {
    background-color: var(--gray-5);
  }
`

const SelectRoot = styled.div`
  color: #fff;

  display: inline-block;

  position: relative;
`

const SelectOption = styled.option``
